import { sha224 } from '@noble/hashes/sha2.js';

/**
 * Mirrors Python's `generate_dl_hash_id_for_cgdo` in umbridge.
 *
 * Formula: str(orgId) + sha224(f"{len(externalId):08d}{externalId}".encode()).hexdigest()
 */
export const computeDlHashIdForCgdo = (
  orgId: number,
  externalId: string,
): string => {
  // Use spread to count Unicode code points, matching Python's len() semantics.
  const lenStr = String([...externalId].length).padStart(8, '0');
  const hashBytes = sha224(new TextEncoder().encode(`${lenStr}${externalId}`));
  const hexHash = Array.from(hashBytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return `${orgId}${hexHash}`;
};
